import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "joinUs",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_2 = {
  class: "modal-dialog become_custome__modal",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "become_custome__form" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = { class: "input-field" }
const _hoisted_10 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "input-field" }
const _hoisted_13 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_14 = { class: "col-sm-6" }
const _hoisted_15 = { class: "input-field" }
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_18 = { class: "col-sm-6" }
const _hoisted_19 = { class: "input-field" }
const _hoisted_20 = { class: "col-sm-6" }
const _hoisted_21 = { class: "browse-input" }
const _hoisted_22 = { class: "browse-field" }
const _hoisted_23 = {
  key: 0,
  class: "browsed-img"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "col-sm-6" }
const _hoisted_26 = { class: "browse-input" }
const _hoisted_27 = { class: "browse-field" }
const _hoisted_28 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_29 = {
  key: 0,
  class: "browsed-img"
}
const _hoisted_30 = { class: "col-sm-12" }
const _hoisted_31 = { class: "input-field" }
const _hoisted_32 = { class: "col-sm-12" }
const _hoisted_33 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_34 = { class: "modal-footer" }
const _hoisted_35 = {
  type: "submit",
  class: "primary-btn-outline"
}
const _hoisted_36 = {
  type: "button",
  class: "dummy-btn",
  "data-bs-dismiss": "modal",
  ref: "dummyButton",
  style: {"display":"none"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[11] || (_cache[11] = _createElementVNode("h5", {
            class: "modal-title",
            id: "exampleModalLabel"
          }, "Join Us", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
          }, [...(_cache[10] || (_cache[10] = [
            _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", {
            onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitApplication && _ctx.submitApplication(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "Name",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.applicationForm.candidateName) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.applicationForm.candidateName]
                    ]),
                    (_ctx.applicationErrors.candidateName)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.applicationErrors.candidateName), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      placeholder: "Email",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.applicationForm.email) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.applicationForm.email]
                    ]),
                    (_ctx.applicationErrors.email)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.applicationErrors.email), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("select", {
                      class: "selectbox",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.applicationForm.designation) = $event))
                    }, [
                      _cache[12] || (_cache[12] = _createElementVNode("option", { value: "" }, "Select Job", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobCategories, (category) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: category.id,
                          value: category.title
                        }, _toDisplayString(category.title), 9, _hoisted_16))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.applicationForm.designation]
                    ]),
                    (_ctx.applicationErrors.designation)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.applicationErrors.designation), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "Name of your Reference (if any)",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.applicationForm.nameOfReference) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.applicationForm.nameOfReference]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "browse-button company-logo" }, "Images", -1)),
                      (_openBlock(), _createElementBlock("input", {
                        type: "file",
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleFileUpload($event))),
                        accept: "image/jpeg,image/jpg,image/png",
                        key: _ctx.fileInputKey
                      }, null, 32))
                    ]),
                    (_ctx.imageUploaded)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("img", {
                            src: _ctx.imageUrl,
                            alt: ""
                          }, null, 8, _hoisted_24)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "browse-button company-logo" }, "Resume", -1)),
                      (_openBlock(), _createElementBlock("input", {
                        type: "file",
                        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleResumeUpload($event))),
                        accept: ".pdf",
                        key: _ctx.fileInputKey
                      }, null, 32)),
                      (!_ctx.selectedResumeFile && _ctx.applicationErrors.candidateResume)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.applicationErrors.candidateResume), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.resumeUploaded)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.ResumeName), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _withDirectives(_createElementVNode("textarea", {
                      placeholder: "Details",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.applicationForm.description) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.applicationForm.description]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", {
                    id: "captchaWidget",
                    class: "g-recaptcha"
                  }, null, -1)),
                  (_ctx.recaptchaError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.recaptchaError), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("button", _hoisted_35, _toDisplayString(_ctx.isSubmitting ? 'Submitting...' : 'Submit'), 1),
              _createElementVNode("button", _hoisted_36, null, 512),
              _createElementVNode("button", {
                type: "button",
                class: "primary-btn-outline",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
              }, "Reset")
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}